<template>
  <div class="home-box flex flex-d ai-c">
    <div class="floorOne" @click="showRegister">
      <NoticeBar scrollable background="rgba(0, 0, 0, .4)" color="#fff" :text="showText" class="noticeBar" />
      <div class="titleDiv"></div>
    </div>
    <div class="activityOne" @click="showRegister">
      <div class="oneTitle flex jc-sb ai-c">
        <img src="@/assets/luckdraw/luckIconLeft.png" alt="" class="iconImg">
        <div class="titleMain">活动1：简单粗暴买就享优惠</div>
        <img src="@/assets/luckdraw/luckIcon.png" alt="" class="iconImg">
      </div>
      <div class="activityMain">
        <img src="@/assets/luckdraw/actOne.png" alt="" class="iconImg">
      </div>
    </div>
    <div class="activityTwo" @click="showRegister">
      <div class="oneTitle flex jc-sb ai-c">
        <img src="@/assets/luckdraw/luckIconLeft.png" alt="" class="iconImg">
        <div class="titleMain">活动2：幸运大转盘 越买越有礼</div>
        <img src="@/assets/luckdraw/luckIcon.png" alt="" class="iconImg">
      </div>
      <div class="activityMain">
        <img src="@/assets/luckdraw/actTwo.png" alt="" class="iconImg">
      </div>
    </div>
    <div class="turntable" @click="showRegister">
      <div class="hasLuckNum">你还有{{luckNum}}次抽奖次数</div>
      <div class="turntableMain flex jc-c ai-c" v-if="isPc">
        <LuckyWheel
          ref="myLucky"
          width="54vw"
          height="54vw"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          :default-config="defaultConfig"
          @start="startCallback"
          @end="endCallback"
        />
      </div>
      <div class="turntableMain flex jc-c ai-c" v-if="!isPc">
        <LuckyWheel
          ref="myLucky"
          width="99vw"
          height="99vw"
          :prizes="prizes"
          :blocks="blocks"
          :buttons="buttons"
          :default-config="defaultConfig"
          @start="startCallback"
          @end="endCallback"
        />
      </div>
    </div>
    <div class="activityRecord">
      <div class="record flex jc-c ai-c" @click="showRegister">
        中奖记录
      </div>
      <div class="activityMain">
        <div class="ruleTitle" @click="showRegister">抽奖规则</div>
        <div class="ruleMain" @click="showRegister">1. 两个活动可同时参加，优惠券及折扣不能叠加使用，以折扣力度更大的为准。实物奖品不受影响。</div>
        <div class="ruleMain" @click="showRegister">2.注册用户赠送首次抽奖次数，活动期间每完成一笔交易可增加一次抽奖机会。</div>
        <div class="ruleMain" @click="showRegister">3.活动页分享给好友且好友注册完成后即可增加一次抽奖次数。</div>
        <div class="ruleMain agreement" @click="canShowAgreement">《弦镜活动抽奖服务协议》</div>
        <div class="ruleMain ruleEnd" @click="showRegister">本活动最终解释权归“北京星图数网科技有限公司”所有</div>
      </div>
    </div>
    <Popup v-model="showActivityRecord">
      <div class="showRecord flex flex-d jc-sb ai-c">
        <div class="recordDiv">
          <div class="recordTitle">中奖记录</div>
          <div class="recordMain">
            <div class="recordItem flex jc-sb ai-c" v-for="item in 20" :key="item">
              <div class="recordItemTitle">恭喜135****8765</div>
              <div class="recordItemContent">获得 <span class="numColor">50</span> 元代金券</div>
            </div>
          </div>
        </div>
        <div class="closeRecord flex jc-c ai-c" @click="closeRecord">知道了</div>
      </div>
    </Popup>
    <Overlay :show="show" @click="show = false">
      <div class="wrapper">
        <img class="logo" src="@/assets/goDown.png">
      </div>
      <div class="goDownTitle">1.点击右上角"..."</div>
      <div class="goDownTitle">2.选择"在浏览器中打开"</div>
      <div class="goDownTitle">3.下载app参加活动</div>
    </Overlay>
    <Popup v-model="showActivityRegister">
      <div class="register flex flex-d ai-c jc-c">
        <div class="registerTitle">注册参与活动送抽奖次数</div>
        <div class="registerMain">
          <div class="registerPhone flex">
            <input type="text" class="inpStyle" v-model="iphone" placeholder="请输入手机号">
          </div>
          <div class="registerCode flex jc-sb ai-c">
            <input type="text" class="inpStyle" v-model="code" placeholder="请输入验证码">
            <div class="getCode" @click="getCodeQuery">{{getCode}}</div>
          </div>
          <div class="registerRadio flex flex-d">
            <div class="flex ai-c">
              <checkbox v-model="agree"></checkbox>
              <div class="agreeDiv">注册即同意</div>
              <div class="protocol" @click="goYszc">《隐私保护政策》</div>
            </div>
            <!-- <div class="protocol protocolOther">《隐私保护政策》</div> -->
          </div>
        </div>
        <div class="registerBtn flex ai-c jc-c" @click="goRegister">注册并下载</div>
      </div>
    </Popup>
    <Popup v-model="showAgreement" round closeable position="bottom" :style="{ height: isPc?'80%':'70%' }">
      <div class="agreementModal">
        <div class="modalTitle">弦镜活动抽奖服务协议</div>
        <div class="modalTime">生效时间2022.6.1</div>
        <p>请您在同意本协议前谨慎阅读并理解相关内容，如您勾选同意即视为您自此发生的抽奖均受该协议约束，包括但不限于前述修改及变更。</p>
        <p>您确认您具备完全民事权利能力和完全民事行为能力，有能力同意并遵守本协议，并对您本协议项下的全部行为独立承担法律责任。若您不具备前述与您行为相适应的民事行为能力，则应获得法定监护人的知情同意。如您尚未成年，请在法定监护人的陪同下阅读和判断是否同意本协议。</p>
        <p>本协议基于《弦镜会员协议》《弦镜隐私政策》制定，与其是不可分割的；由于您使用的软件版本、设备、操作系统等不同以及第三方原因可能导致您实际可使用的具体服务有差别，由此可能给您带来的不便，您表示理解，并不会因此向弦镜及其关联公司提出任何主张或追究会员购及其关联公司任何责任。</p>
        <h2>一． 用户须知</h2>
        <p>本次抽奖的奖品均为弦镜提供，实物奖品承诺在用户中奖后15个工作日内给已填写地址的中奖用户寄出。虚拟物品以优惠码形式发放，用户可根据优惠码进行使用，有效期为活动时间内。超过时间视为自动放弃使用权</p>
        <h2>二． 特别注意</h2>
        <p>举办方有权判断用户使用途径是否合理合法，并且依据判断进行对中奖结果的审核，活动的最终解释权归本公司所有。</p>
      </div>
    </Popup>
  </div>
</template>

<script>
import { NoticeBar } from 'vant';
import { Toast } from 'vant';
import { Popup } from 'vant';
import { Overlay } from 'vant';
import { Checkbox } from 'vant';
import { Dialog } from 'vant';
import axios from "axios";
export default {
  name: 'carrousel',
  data() {
    return {
      showText: '恭喜185****0921用户获得一等奖<苹果手机一部> 恭喜188****1025用户获得一等奖<苹果手机一部> 恭喜139****2286用户获得三等奖<抖音VIP服务一个月> 恭喜138****2121用户获得三等奖<抖音VIP服务一个月> 恭喜139****9821用户获得四等奖<抖音8折优惠券> 恭喜138****2121用户获得四等奖<抖音8折优惠券> 恭喜155****6212用户获得四等奖<抖音8折优惠券> 恭喜177****4435用户获得四等奖<抖音8折优惠券> 恭喜185****7621用户获得四等奖<抖音8折优惠券> 恭喜139****0721用户获得三等奖<抖音VIP服务一个月> 恭喜137****8612用户获得四等奖<抖音8折优惠券> 恭喜139****3722用户获得四等奖<抖音8折优惠券> 恭喜186****0198用户获得四等奖<抖音8折优惠券> 恭喜186****6218用户获得四等奖<抖音8折优惠券> 恭喜155****6522用户获得四等奖<抖音8折优惠券> 恭喜135****6930用户获得四等奖<抖音8折优惠券> 恭喜136****3750用户获得四等奖<抖音8折优惠券> 恭喜159****3674用户获得三等奖<抖音VIP服务一个月> 恭喜139****0721用户获得四等奖<抖音8折优惠券> 恭喜182****5107用户获得四等奖<抖音8折优惠券> 恭喜139****2726用户获得四等奖<抖音8折优惠券> 恭喜157****2135用户获得四等奖<抖音8折优惠券> 恭喜183****7862用户获得三等奖<抖音VIP服务一个月> 恭喜147****1862用户获得四等奖<抖音8折优惠券>',
      luckNum: 1,//抽奖次数
      blocks: [
        {
          imgs: [{
            src: require('@/assets/luckdraw/bigLuck.png'),
            width: '100%',
            height: '100%',
            rotate: true
          }]
        }
      ],//背景图片
      prizes: [
        { 
          imgs: [{
            src: require('@/assets/luckdraw/prizeOne.png'),
            width: '10%',
            top: '85%'
          }],
          fonts: [
            { text: '苹果手机', top: '65%', fontSize: '14px',fontColor:"#947600" },
          ]
        },
        { 
          imgs: [{
            src: require('@/assets/luckdraw/prizeTwo.png'),
            width: '20%',
            top: '95%'
          }],
          fonts: [
            { text: '优惠券', top: '70%', fontSize: '14px',fontColor:"#947600" },
          ]
        },
        { 
          imgs: [{
            src: require('@/assets/luckdraw/thankYou.png'),
            width: '20%',
            top: '85%'
          }],
          fonts: [
            { text: '谢谢参与', top: '65%', fontSize: '14px',fontColor:"#947600" },
          ]
        },
        { 
          imgs: [{
            src: require('@/assets/luckdraw/prizeThree.png'),
            width: '20%',
            top: '95%'
          }],
          fonts: [
            { text: '抖音VIP', top: '70%', fontSize: '14px',fontColor:"#947600" },
          ]
        },
        { 
          imgs: [{
            src: require('@/assets/luckdraw/prizeFour.png'),
            width: '20%',
            top: '85%'
          }],
          fonts: [
            { text: '8折券', top: '65%', fontSize: '14px',fontColor:"#947600" },
          ]
        },
        { 
          imgs: [{
            src: require('@/assets/luckdraw/thankYou.png'),
            width: '20%',
            top: '85%'
          }],
          fonts: [
            { text: '谢谢参与', top: '65%', fontSize: '14px',fontColor:"#947600" },
          ]
        },
      ],//中奖内容
      buttons: [{
        radius: '45%',
        imgs: [{
          src: require('@/assets/luckdraw/pointer.png'),
          width: '50%',
          top: '-65%'
        }]
      }],//按钮
      defaultConfig: {
        offsetDegree: -30,//指针偏移
      },//默认配置
      winThePrize: 0,//中奖索引
      showActivityRecord: false,//中奖记录弹窗
      show: false,//提示下载弹窗
      shareContent:"",//分享内容
      showActivityRegister: false,//注册弹窗
      getCode: "获取验证码",
      agree: false,//是否勾选
      iphone: "",//手机号
      code: "",//验证码
      logRepeatedly:true,
      count: 60,
      isPc:false,
      showAgreement:false,//是否显示协议
    }
  },
  components: {
    NoticeBar,
    Popup,
    Overlay,
    Checkbox,
    Dialog,
  },
  created() {
    //屏幕宽度大于1100px时，设置为pc端
    if(document.body.clientWidth>1100){
      this.isPc=true;
    }
  },
  mounted () {
    if(window.location.href.split("?").length!=1){
      this.shareContent=window.location.href.split("?")[1].split("=")[1];
    };
  },
  computed: {},
  methods: {
    // 点击抽奖按钮会触发star回调
    startCallback () {},
    // 抽奖结束会触发end回调
    endCallback () {},
    //显示中奖记录弹窗
    showRecord(){},
    //关闭中奖记录弹窗
    closeRecord(){
      this.showActivityRecord = false;
    },
    //打开注册弹框
    showRegister(){
      this.showActivityRegister = true;
    },
    //获取验证码
    getCodeQuery(){
      if(!this.iphone) {
        Toast.fail('手机号不能为空');
        return
      }
      const that=this;
      if(that.logRepeatedly){
        that.logRepeatedly=false
        let url = "http://m.synlen.com/sendMail/sendCode"
        if(process.env.NODE_ENV !== 'development'){
          url = "http://m.synlen.com/sendMail/sendCode"
        }
        axios.get(url,{
    　　   params: { 
            account: this.iphone
          }
        }).then(res => {
          if(res.data.code== 200 ) {
            Toast.success('发送成功');
            that.logRepeatedly=true
            var setinter = setInterval(function () {
              that.count--
              that.getCode=`(${that.count})`+''
              that.logRepeatedly=false;
              if(!that.count){
                that.getCode=`重新发送`;
                clearInterval(setinter)
                that.count = 60
                that.logRepeatedly=true;
              }
            },1000)
          } 
        })
      }
    },
    //打开新页面跳转隐私政策
    goYszc(){
      window.open("http://yinsi.synlen.com/");
    },
    //去注册
    goRegister(){
      if(!this.iphone) {
        Toast.fail('手机号不能为空');
        return
      }
      if(!this.code) {
        Toast.fail('验证码不能为空');
        return
      }
      if(!this.agree) {
        Toast.fail('请先勾选同意协议！');
        return
      }
      let url = "http://m.synlen.com/luckRegister"
      if(process.env.NODE_ENV == 'development'){
        url = "http://m.synlen.com/luckRegister"
      }
      let formData = new FormData();
      formData.append('account', this.iphone);
      formData.append('code', this.code);
      formData.append("shareContent", this.shareContent.replace('%2F', '/'));
      axios.post(url,formData).then((res) => {
        if(res&&res.data&&res.data.code==200){
          Toast.success({
            message: res.data.msg,
            duration: 1500,
            onClose: () => {
              //注册成功去下载
              this.goDownLoad();
            }
          });
          // Dialog.confirm({
          //   title: '提示',
          //   message: res.data.msg,
          //   cancelButtonText: '取消',
          //   confirmButtonText: this.isPc?'官网':'去下载',
          // }).then(() => {
          //   //注册成功去下载
          //     this.goDownLoad();
          // })
          // .catch(() => {
          //   // on cancel
          // });
        }else{
          Toast.fail({
            message: res.data.msg,
            duration: 1500,
            onClose: () => {
              if(res.data.code!=215){
                //215是验证码错误
                //注册成功去下载
                this.goDownLoad();
              }
            }
          });
        }
      })
    },
    //去下载
    goDownLoad(){
      let sUserAgent = navigator.userAgent.toLowerCase()
      let bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
      let bIsMidp = sUserAgent.match(/midp/i) == 'midp'
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
      let bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
      let bIsAndroid = sUserAgent.match(/android/i) == 'android'
      let bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
      let bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
      if (
        !(
          bIsIpad ||
          bIsIphoneOs ||
          bIsMidp ||
          bIsUc7 ||
          bIsUc ||
          bIsAndroid ||
          bIsCE ||
          bIsWM
        )
      ) {
        //pc端
        window.open("http://www.synlen.com/#/home");
        return
      };
      var u = navigator.userAgent;
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var isAndroid= u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
      //u.toLowerCase().match(/MicroMessenger/i) == "micromessenger" //微信自带的浏览器打开
      if(isIos){
        //ios
        // console.log('ios浏览器')
        if(u.toLowerCase().match(/MicroMessenger/i) == "micromessenger"){
          //微信自带的浏览器打开
          this.canshow=false;
          this.show=true;
          // window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
        }else{
          window.location.href = 'https://apps.apple.com/cn/app/id1601918648';
        }
      }else if(isAndroid){
        //安卓
        // console.log('安卓浏览器')
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.syntun.synlen';
      }
    },
    //显示服务协议
    canShowAgreement(){
      this.showAgreement=true;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/styles/common.scss";
.home-box {
  background-color: #632FB5;
  overflow-x: hidden;
  .floorOne{
    width: 100%;
    background: url("~@/assets/luckdraw/luckTop.png") no-repeat;
    background-size: 100% 100%;
    padding: 0px 0 100px;
    .titleDiv{
      width: 542px;
      height: 222px;
      background: url("~@/assets/luckdraw/lockTitle.png") no-repeat;
      background-size: 100% 100%;
      margin-top: 58px;
      margin: 58px auto 130px;
    }
  }
  .activityOne,.activityTwo,.activityRecord{
    width: 100%;
    margin-top: -130px;
    .oneTitle{
      padding: 0 60px;
      .iconImg{
        width: 52px;
        height: 16px;
      }
      .titleMain{
        font-size: 36px;
        font-family: 'Adobe Heiti Std';
        font-weight: normal;
        color: #FFFFFF;
      }
    }
    .activityMain{
      width: 605px;
      // height: 500px;
      background: #632FB5;
      box-shadow: 0px 0px 30px rgba(78, 253, 228, 0.4) inset;
      border-radius: 20px;
      margin: 40px auto;
      padding: 35px;
      img{
        width: 100%;
        height: 100%;
      }
      div{
        color: #fff;
      }
      .ruleTitle{
        font-size: 36px;
        font-family: 'Adobe Heiti Std';
        font-weight: normal;
      }
      .ruleMain{
        font-size: 30px;
        font-family: 'Source Han Sans CN';
        font-weight: 400;
        text-align: left;
        margin: 40px 0;
      }
      .agreement{
        font-size: 24px;
        font-family: 'Source Han Sans CN';
        font-weight: 400;
        color: #2899F2;
        text-align: center !important;
        margin: 40px 0 0px;
      }
      .ruleEnd{
        font-size: 24px;
        text-align: center;
        margin: 10px 0 40px;
      }
    }
    .record{
      width: 336px;
      height: 70px;
      background: linear-gradient(0deg, #FFC600, #FFF945);
      box-shadow: 0px 8px 0px 0px rgba(255, 148, 8, 0.8);
      border-radius: 35px;
      margin: 0 auto;
      font-size: 40px;
      font-family: 'Source Han Sans CN';
      font-weight: bold;
      color: #FF1350;
      cursor: pointer;
    }
  }
  .activityTwo,.activityRecord{
    margin-top: 30px;
  }
  .activityTwo{
    .activityMain{
      height: 460px;
    }
  }
  .turntable{
    width: 100%;
    height: 970px;
    background: url("~@/assets/luckdraw/turntableBg.png") no-repeat;
    background-size: 100% 100%;
    padding: 80px 0 120px;
    .hasLuckNum{
      width: 420px;
      height: 75px;
      font-size: 30px;
      font-family: 'Source Han Sans CN';
      font-weight: bold;
      color: #FFFFFF;
      background: url("~@/assets/luckdraw/luckNum.png") no-repeat;
      background-size: 100% 100%;
      margin: 30px auto -120px;
      line-height: 75px;
    }
    .turntableMain{
      width: 1000px;
      height: 1000px;
      background: url("~@/assets/luckdraw/turntableMain.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      margin-left: -125px;
    }
  }
  .showRecord{
    width: 656px;
    height: 1000px;
    background: url("~@/assets/luckdraw/recordBg.png") no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    padding: 190px 0 30px;
    box-sizing: border-box;
    .recordDiv{
      width: 100%;
      .recordTitle{
        font-size: 38px;
        font-family: 'Adobe Heiti Std';
        font-weight: normal;
        color: #FF1350;
      }
      .recordMain{
        height: 500px;
        font-size: 28px;
        font-family: 'Source Han Sans CN';
        font-weight: 400;
        color: #333333;
        padding: 20px 82px 40px;
        box-sizing: border-box;
        overflow-y: auto;
        .recordItem{
          margin: 20px 0;
          .numColor{
            color: #FF1350;
          }
        }
      }
    }
    .closeRecord{
      width: 493px;
      height: 88px;
      background: #FFE62B;
      border-radius: 44px;
      font-size: 36px;
      font-family: 'Source Han Sans CN';
      font-weight: 400;
      color: #FF1350;
    }
  }
  .register{
    width: 656px;
    height: 800px;
    background: url("~@/assets/luckdraw/registerbg.png") no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    padding: 70px 40px 30px;
    box-sizing: border-box;
    .registerTitle{
      font-size: 36px;
      font-family: "Source Han Sans CN";
      font-weight: bold;
      color: #585858;
    }
    .registerMain{
      width: 100%;
      height: 500px;
      .registerPhone,.registerCode{
        border-bottom: 2px solid #A1A1A1;
        padding: 70px 0 20px;
        .inpStyle,.inpStyle:focus {
          width: 100%;
          height: 60px;
          border: none !important;
          outline:none;
          font-size: 32px;
          font-family: "Source Han Sans CN";
          font-weight: bold;
          color: #A1A1A1;
        }
        .getCode{
          font-size: 30px;
          font-family: "Source Han Sans CN";
          font-weight: bold;
          color: #617AE4;
          width: 160px;
          flex: 0 0 160px;
        }
      }
      .registerRadio{
        text-align: left;
        margin-top: 50px;
        /deep/ .van-checkbox__icon{
          font-size: 29px !important;
        }
        .agreeDiv{
          font-size: 24px;
          font-family: "Source Han Sans CN";
          font-weight: bold;
          color: #838383;
          padding: 0 10px 0 15px;
        }
        .protocol{
          font-size: 24px;
          font-family: "Source Han Sans CN";
          font-weight: bold;
          color: #588EF2;
        }
        .protocolOther{
          padding-left: 29px;
          margin-top: 10px;
        }
      }
    }
    .registerBtn{
      width: 517px;
      height: 99px;
      background: linear-gradient(90deg, #6314A9, #8F6FD4);
      box-shadow: 0px 5px 5px 0px rgba(122, 174, 239, 0.44);
      font-size: 36px;
      font-family: "Source Han Sans CN";
      font-weight: bold;
      color: #FFFFFF;
      border-radius: 50px;
    }
  }
  .agreementModal{
    background-color: #fff;
    padding: 80px 30px 40px;
    .modalTitle{
      font-size: 36px;
      font-family: "Source Han Sans CN";
      font-weight: bold;
      color: #333333;
    }
    .modalTime{
      font-size: 26px;
      font-family: "Source Han Sans CN";
      font-weight: 400;
      color: #838383;
      margin: 20px 0 40px;
    }
    p{
      font-size: 26px;
      font-family: "Source Han Sans CN";
      font-weight: 400;
      color: #333333;
      line-height: 1.8;
      margin: 20px 0;
      text-align: left;
    }
    h2{
      font-size: 32px;
      font-family: "Source Han Sans CN";
      font-weight: 400;
      color: #333333;
      line-height: 1.8;
      margin: 20px 0;
      text-align: left;
    }
  }
}
::-webkit-input-placeholder { /* WebKit, Blink, Edge */    color:    #A1A1A1; }

:-moz-placeholder { /* Mozilla Firefox 4 to 18 */   color:    #A1A1A1; }

::-moz-placeholder { /* Mozilla Firefox 19+ */   color:    #A1A1A1; }

:-ms-input-placeholder { /* Internet Explorer 10-11 */   color:    #A1A1A1; }
.van-popup--center{
  background: none;
  margin-top: -70px;
}
//下载
.wrapper{
  text-align: right;
  padding: 0 10px;
  .logo{
    width: 250px;
    margin: 40px;
  }
}
.goDownTitle{
  width: 100%;
  text-align: left;
  color: #fff;
  font-size: 60px;
  padding: 0 30px;
}
/deep/ .van-overlay{
  background-color: rgba(0,0,0,.8);
}
//适配pc，大于1100px
@media screen and (min-device-width:1100px){
  .home-box {
    width: 375px;
    margin: 0 auto;
    background-color: #632FB5;
    overflow-x: hidden;
    .floorOne{
      width: 100%;
      background: url("~@/assets/luckdraw/luckTop.png") no-repeat;
      background-size: 100% 100%;
      padding: 0px 0 50px;
      .noticeBar{
        height: 40px;
        font-size: 20px;
      }
      .titleDiv{
        width: 271px;
        height: 111px;
        background: url("~@/assets/luckdraw/lockTitle.png") no-repeat;
        background-size: 100% 100%;
        margin-top: 29px;
        margin: 29px auto 65px;
      }
    }
    .activityOne,.activityTwo,.activityRecord{
      width: 100%;
      margin-top: -65px;
      .oneTitle{
        padding: 0 30px;
        .iconImg{
          width: 26px;
          height: 8px;
        }
        .titleMain{
          font-size: 18px;
          font-family: 'Adobe Heiti Std';
          font-weight: normal;
          color: #FFFFFF;
        }
      }
      .activityMain{
        width: 303px;
        // height: 500px;
        background: #632FB5;
        box-shadow: 0px 0px 30px rgba(78, 253, 228, 0.4) inset;
        border-radius: 10px;
        margin: 20px auto;
        padding: 18px;
        img{
          width: 100%;
          height: 100%;
        }
        div{
          color: #fff;
        }
        .ruleTitle{
          font-size: 18px;
          font-family: 'Adobe Heiti Std';
          font-weight: normal;
        }
        .ruleMain{
          font-size: 15px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          text-align: left;
          margin: 20px 0;
        }
        .ruleEnd{
          font-size: 12px;
          text-align: center;
        }
      }
      .record{
        width: 168px;
        height: 35px;
        background: linear-gradient(0deg, #FFC600, #FFF945);
        box-shadow: 0px 8px 0px 0px rgba(255, 148, 8, 0.8);
        border-radius: 18px;
        margin: 0 auto;
        font-size: 20px;
        font-family: 'Source Han Sans CN';
        font-weight: bold;
        color: #FF1350;
        cursor: pointer;
      }
    }
    .activityTwo,.activityRecord{
      margin-top: 15px;
    }
    .activityTwo{
      .activityMain{
        height: 230px;
      }
    }
    .turntable{
      width: 100%;
      height: 485px;
      background: url("~@/assets/luckdraw/turntableBg.png") no-repeat;
      background-size: 100% 100%;
      padding: 40px 0 60px;
      .hasLuckNum{
        width: 210px;
        height: 38px;
        font-size: 15px;
        font-family: 'Source Han Sans CN';
        font-weight: bold;
        color: #FFFFFF;
        background: url("~@/assets/luckdraw/luckNum.png") no-repeat;
        background-size: 100% 100%;
        margin: 15px auto -60px;
        line-height: 38px;
      }
      .turntableMain{
        width: 500px;
        height: 500px;
        background: url("~@/assets/luckdraw/turntableMain.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        margin-left: -62.5px;
      }
    }
    .showRecord{
      width: 328px;
      height: 500px;
      background: url("~@/assets/luckdraw/recordBg.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      padding: 95px 0 15px;
      box-sizing: border-box;
      .recordDiv{
        width: 100%;
        .recordTitle{
          font-size: 18px;
          font-family: 'Adobe Heiti Std';
          font-weight: normal;
          color: #FF1350;
        }
        .recordMain{
          height: 250px;
          font-size: 14px;
          font-family: 'Source Han Sans CN';
          font-weight: 400;
          color: #333333;
          padding: 10px 41px 20px;
          box-sizing: border-box;
          overflow-y: auto;
          .recordItem{
            margin: 10px 0;
            .numColor{
              color: #FF1350;
            }
          }
        }
      }
      .closeRecord{
        width: 246px;
        height: 44px;
        background: #FFE62B;
        border-radius: 22px;
        font-size: 18px;
        font-family: 'Source Han Sans CN';
        font-weight: 400;
        color: #FF1350;
      }
    }
    .register{
      width: 300px;
      height: 300px;
      background: url("~@/assets/luckdraw/registerbg.png") no-repeat;
      background-size: 100% 100%;
      margin: 0 auto;
      padding: 20px 20px 15px;
      box-sizing: border-box;
      .registerTitle{
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: bold;
        color: #585858;
      }
      .registerMain{
        width: 100%;
        height: 250px;
        .registerPhone,.registerCode{
          border-bottom: 2px solid #A1A1A1;
          padding: 20px 0 10px;
          .inpStyle,.inpStyle:focus {
            width: 100%;
            height: 30px;
            border: none !important;
            outline:none;
            font-size: 16px;
            font-family: "Source Han Sans CN";
            font-weight: bold;
            color: #A1A1A1;
          }
          .getCode{
            font-size: 15px;
            font-family: "Source Han Sans CN";
            font-weight: bold;
            color: #617AE4;
            width: 80px;
            flex: 0 0 80px;
          }
        }
        .registerRadio{
          text-align: left;
          margin-top: 25px;
          /deep/ .van-checkbox__icon{
            font-size: 15px !important;
          }
          .agreeDiv{
            font-size: 12px;
            font-family: "Source Han Sans CN";
            font-weight: bold;
            color: #838383;
            padding: 0 5px 0 8px;
          }
          .protocol{
            font-size: 12px;
            font-family: "Source Han Sans CN";
            font-weight: bold;
            color: #588EF2;
          }
          .protocolOther{
            padding-left: 15px;
            margin-top: 5px;
          }
        }
      }
      .registerBtn{
        width: 259px;
        height: 50px;
        background: linear-gradient(90deg, #6314A9, #8F6FD4);
        box-shadow: 0px 5px 5px 0px rgba(122, 174, 239, 0.44);
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: bold;
        color: #FFFFFF;
        border-radius: 25px;
      }
    }
    .van-popup{
      width: 375px;
      left: 50%;
      margin-left: -187.5px;
    }
    .agreementModal{
      // width: 375px;
      background-color: #fff;
      padding: 80px 30px 20px;
      .modalTitle{
        font-size: 24px;
        font-family: "Source Han Sans CN";
        font-weight: bold;
        color: #333333;
      }
      .modalTime{
        font-size: 16px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #838383;
        margin: 20px 0 20px;
      }
      p{
        font-size: 16px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #333333;
        line-height: 1.8;
        margin: 20px 0;
        text-align: left;
      }
      h2{
        font-size: 18px;
        font-family: "Source Han Sans CN";
        font-weight: 400;
        color: #333333;
        line-height: 1.8;
        margin: 20px 0;
        text-align: left;
      }
      .pLast{
        text-align: center;
        font-size: 12px;
        color: #333333;
      }
    }
    .van-popup--center{
      margin-left: 0 !important;
    }
  }
  .van-popup--center{
    margin-top: 20px;
  }
}
</style>